import React, { useState } from 'react';
import cx from 'classnames';
import {
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  Dialog,
  DialogTitle,
} from '@material-ui/core';

import { BRAND_VOICE_GENERATION_TYPE_LABEL } from 'src/data/brandVoice';
import { useHandlers } from './useHandlers';
import { useStyles } from './useStyles';

export const ProjectBrandVoicesSelectionPopup = ({
  open,
  onSubmit,
  onClose,
  currentBrandVoice,
  brandVoices,
  generationTool,
  type,
  origin,
  onUpdatedCallback,
}) => {
  const styles = useStyles();
  const [applyAll, setApplyAll] = useState(false);
  const [selectedBrandVoiceId, setSelectedBrandVoiceId] = useState(currentBrandVoice?.id);
  const { handleSubmit } = useHandlers({
    onClose,
    onSubmit,
    onUpdatedCallback,
  });
  const assetLabel = BRAND_VOICE_GENERATION_TYPE_LABEL[type] || '';
  const assetDescription = <span className={styles.underline}>{assetLabel.toLowerCase()}</span>;

  const handleApplyAll = () => {
    setApplyAll((p) => !p);
  };

  const handleRadioChange = (e) => {
    setSelectedBrandVoiceId(e.target.value);
  };

  const handleUpdateBrandVoice = () => {
    handleSubmit({
      brandVoiceId: selectedBrandVoiceId,
      generationTool,
      type,
      applyAll,
      origin,
    });
  };
  if (brandVoices?.length <= 1) {
    return;
  }

  return (
    <Dialog
      classes={{ paper: styles.root }}
      onClose={onClose}
      data-testid="brandVoicePopup"
      onSubmit={handleUpdateBrandVoice}
      onCancel={onClose}
      open={open}
    >
      <DialogTitle disableTypography>Brand voice Settings</DialogTitle>
      <DialogContent>
        <Typography className={styles.description}>
          {assetLabel} are part of a brand voice.
          <br />
          Select the brand voice that includes the {assetDescription} you want to work with.
        </Typography>
        <div className={styles.radioCardsWrapper}>
          <RadioGroup
            className={styles.radioGroup}
            name="BrandVoiceRadios"
            value={selectedBrandVoiceId}
            onChange={handleRadioChange}
          >
            {brandVoices.map((bv) => (
              <FormControlLabel
                className={cx(styles.radioItem, {
                  [styles.selected]: selectedBrandVoiceId === bv.id,
                })}
                key={bv.id}
                value={bv.id}
                control={<Radio color="primary" />}
                label={bv.name}
                data-testid={`BrandVoice${bv.id}Radio`}
              />
            ))}
          </RadioGroup>
        </div>
      </DialogContent>
      <DialogActions className={styles.dialogActions}>
        <FormControlLabel
          classes={{ label: styles.applyAllLabel }}
          className={styles.applyAllLabel}
          control={
            <Checkbox
              className={styles.checkbox}
              onChange={handleApplyAll}
            />
          }
          label="Apply selected brand voice to all assets"
        />
        <div className={styles.actionsWrapper}>
          <Button
            className={styles.actionButton}
            onClick={onClose}
            variant="text"
            color="primary"
          >
            Close
          </Button>
          <Button
            className={styles.actionButton}
            onClick={handleUpdateBrandVoice}
            variant="contained"
            color="primary"
          >
            Update
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};
